<script lang="ts">
	import { CheckCircle, ExclamationCircle, InformationCircle, XCircle } from 'svelte-heros-v2';

  export let toastType = 'default';

  let toastTypes = [
    { format: 'default', component: InformationCircle, style: 'text-blue-500' },
    { format: 'success', component: CheckCircle, style: 'text-green-500' },
    { format: 'warning', component: ExclamationCircle, style: 'text-yellow-500' },
    { format: 'error', component: XCircle, style: 'text-red-500' },
  ];

  let iconComponent = toastTypes.find((type) => type.format === toastType)?.component;
  let iconStyle = toastTypes.find((type) => type.format === toastType)?.style;
</script>

<svelte:component this={iconComponent} variation="solid" class="{iconStyle} h-6 w-6 outline-none" />
